import { render, staticRenderFns } from "./OrderPage.vue?vue&type=template&id=7d7ee228"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"
import style0 from "./OrderPage.vue?vue&type=style&index=0&id=7d7ee228&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports